export const parseCurrencyToNumber = (v) => {
  if (typeof v === "number") return v;
  if (typeof v === "string") {
    const digits = v.replace(/[^\d.-]/g, "");
    if (digits === "" || digits === "-" || digits === "." || digits === "-.")
      return 0;
    const n = Number(digits);
    return Number.isFinite(n) ? n : 0;
  }
  return 0;
};
